import React, { useState, useEffect } from "react";
import { Reveal, Rich, BGMark, PortraitSlot, Lightbox, fotoFocus } from "./primitives";

/* ---------- Bio-venster bestuur ---------- */
function BioModal({ m, portret, onClose }) {
  const line = "var(--line)";
  const gold = "var(--gold)";
  const subFg = "rgba(243,234,215,0.82)";
  return (
    <div onClick={onClose} data-testid="bio-modal" style={{
      position: "fixed", inset: 0, zIndex: 1000, background: "rgba(10,9,8,0.88)",
      backdropFilter: "blur(10px)", display: "flex", alignItems: "center",
      justifyContent: "center", padding: "clamp(16px, 3vw, 40px)", animation: "bioFade .3s var(--ease)",
    }}>
      <article onClick={(e) => e.stopPropagation()} className="bio-modal-grid" style={{
        background: "var(--ink)", color: "var(--cream)", maxWidth: 1080, width: "100%",
        maxHeight: "90vh", overflow: "auto", border: `1px solid ${gold}`,
        padding: "clamp(32px, 5vw, 64px)", display: "grid",
        gridTemplateColumns: "minmax(0, 1fr) 1.4fr", gap: "clamp(24px, 3vw, 48px)",
        position: "relative", animation: "bioRise .4s var(--ease)",
      }}>
        <button onClick={onClose} aria-label="Sluit" data-testid="bio-modal-close" style={{
          all: "unset", cursor: "pointer", position: "absolute", top: 20, right: 24,
          fontFamily: "var(--mono)", fontSize: 11, letterSpacing: "0.22em",
          textTransform: "uppercase", color: gold,
        }}>Sluit ×</button>

        <div>
          <div style={{
            aspectRatio: "3/4", background: "#1a1611", border: `1px solid ${line}`,
            overflow: "hidden", position: "relative",
          }}>
            {portret ? (
              <img src={portret.url} alt={`${m.voornaam} ${m.achternaam}`} style={{
                width: "100%", height: "100%", objectFit: "cover", filter: "grayscale(0.3) contrast(1.05)",
              }} />
            ) : (
              <div style={{
                position: "absolute", inset: 0, display: "flex",
                alignItems: "center", justifyContent: "center",
                background: "repeating-linear-gradient(135deg, transparent 0, transparent 16px, rgba(243,234,215,0.03) 16px, rgba(243,234,215,0.03) 17px)",
              }}>
                <span style={{ fontFamily: "var(--serif)", fontSize: "clamp(38px, 4vw, 64px)", color: "rgba(201,169,97,0.32)" }}>
                  {m.voornaam?.[0]}{m.achternaam?.[0]}
                </span>
              </div>
            )}
            <div style={{
              position: "absolute", bottom: 0, left: 0, right: 0, padding: "12px 14px",
              background: "linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(10,9,8,0.85) 100%)",
              display: "flex", justifyContent: "space-between", fontFamily: "var(--mono)",
              fontSize: 10, letterSpacing: "0.2em", textTransform: "uppercase", color: gold,
            }}>
              <span>Portret · {m.nummer}</span>
              <span>SWOF</span>
            </div>
          </div>
        </div>

        <div>
          <Rich className="eyebrow" html={`${m.rol} · ${m.tag}`} style={{ color: gold, marginBottom: 16 }} />
          <h3 style={{
            fontFamily: "var(--serif)", fontSize: "clamp(36px, 4vw, 60px)",
            lineHeight: 0.98, letterSpacing: "-0.015em", margin: "0 0 20px", fontWeight: 400,
          }}>
            {m.voornaam} <em>{m.achternaam}</em>
          </h3>
          <Rich as="p" html={m.dek} style={{
            fontFamily: "var(--serif)", fontStyle: "italic", fontSize: "clamp(17px, 1.4vw, 22px)",
            lineHeight: 1.4, margin: "0 0 28px", color: gold, maxWidth: "40ch",
          }} />

          {(m.bullets || []).length > 0 && (
            <ul style={{ listStyle: "none", padding: 0, margin: "0 0 28px", borderTop: `1px solid ${line}` }}>
              {m.bullets.map((b, k) => (
                <li key={k} style={{
                  padding: "12px 0", borderBottom: `1px solid ${line}`,
                  display: "grid", gridTemplateColumns: "28px 1fr", gap: 14,
                  fontFamily: "var(--serif)", fontSize: "clamp(14px, 1.1vw, 17px)",
                  lineHeight: 1.4, color: subFg,
                }} dangerouslySetInnerHTML={{
                  __html: `<span style="font-family:var(--mono);font-size:10px;color:${gold};letter-spacing:0.18em;opacity:0.75">${String(k + 1).padStart(2, "0")}</span><span>${b}</span>`,
                }} />
              ))}
            </ul>
          )}

          {(m.body || []).map((para, k) => (
            <Rich key={k} as="p" html={para} style={{
              fontFamily: "var(--serif)", fontSize: "clamp(15px, 1.2vw, 18px)",
              lineHeight: 1.6, margin: "0 0 16px", maxWidth: "58ch", color: subFg, textWrap: "pretty",
            }} />
          ))}

          {m.citaat && (
            <blockquote style={{
              margin: "28px 0 0", paddingLeft: 20, borderLeft: `1px solid ${gold}`,
              fontFamily: "var(--serif)", fontStyle: "italic", fontSize: "clamp(18px, 1.6vw, 24px)",
              lineHeight: 1.35, color: "var(--cream)", maxWidth: "34ch",
            }}>
              <Rich as="span" html={m.citaat} />
              <footer style={{
                marginTop: 12, fontFamily: "var(--mono)", fontStyle: "normal", fontSize: 10,
                letterSpacing: "0.22em", textTransform: "uppercase", color: gold, opacity: 0.8,
              }}>{m.voornaam} {m.achternaam}</footer>
            </blockquote>
          )}
        </div>
      </article>
    </div>
  );
}

function BestuurThumb({ m, portret, isOpen, onClick }) {
  const line = "var(--line)";
  const gold = "var(--gold)";
  const subFg = "rgba(243,234,215,0.6)";
  return (
    <button onClick={onClick} data-testid={`bestuur-thumb-${m.nummer}`} style={{
      all: "unset", cursor: "pointer", display: "block",
      border: `1px solid ${isOpen ? gold : line}`, background: "transparent",
      transition: "border-color .3s var(--ease), transform .3s var(--ease)", padding: 0,
    }}
      onMouseEnter={(e) => { e.currentTarget.style.borderColor = gold; }}
      onMouseLeave={(e) => { if (!isOpen) e.currentTarget.style.borderColor = line; }}
    >
      <div style={{ aspectRatio: "3/4", background: "#1a1611", position: "relative", overflow: "hidden" }}>
        {portret ? (
          <img src={portret.url} alt={`${m.voornaam} ${m.achternaam}`} style={{
            width: "100%", height: "100%", objectFit: "cover",
            filter: "grayscale(0.4) contrast(1.05)",
            transition: "filter .4s var(--ease), transform .6s var(--ease)",
          }} />
        ) : (
          <div style={{
            position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center",
            background: "repeating-linear-gradient(135deg, transparent 0, transparent 16px, rgba(243,234,215,0.03) 16px, rgba(243,234,215,0.03) 17px)",
          }}>
            <span style={{ fontFamily: "var(--serif)", fontSize: 34, color: gold, opacity: 0.45 }}>
              {m.voornaam?.[0]}{m.achternaam?.[0]}
            </span>
          </div>
        )}
        <div style={{
          position: "absolute", top: 10, left: 12, fontFamily: "var(--mono)", fontSize: 9,
          letterSpacing: "0.22em", textTransform: "uppercase", color: gold,
        }}>{m.nummer}</div>
      </div>
      <div style={{ padding: "14px 14px 16px", borderTop: `1px solid ${line}` }}>
        <div style={{
          fontFamily: "var(--serif)", fontSize: "clamp(15px, 1.2vw, 19px)", lineHeight: 1.15,
          fontWeight: 400, letterSpacing: "-0.005em", minHeight: "2.3em",
        }}>
          {m.voornaam && <>{m.voornaam} </>}
          <em>{m.achternaam}</em>
        </div>
        <div style={{
          marginTop: 6, fontFamily: "var(--mono)", fontSize: 9, letterSpacing: "0.2em",
          textTransform: "uppercase", color: subFg,
        }}>{m.rol}</div>
        <div style={{
          marginTop: 10, fontFamily: "var(--mono)", fontSize: 9, letterSpacing: "0.2em",
          textTransform: "uppercase", color: gold, display: "flex", alignItems: "center",
          gap: 6, opacity: isOpen ? 1 : 0.65,
        }}>Bio <span>→</span></div>
      </div>
    </button>
  );
}

/* ———— 10. bestuur ———— */
export function BlockBestuur({ inhoud, bestuursleden, mediaById }) {
  const [openId, setOpenId] = useState(null);
  const leden = bestuursleden.filter((b) => b.zichtbaar);
  const open = leden.find((m) => m.id === openId) || null;
  const line = "var(--line)";
  const gold = "var(--gold)";
  const subFg = "rgba(243,234,215,0.75)";

  useEffect(() => {
    if (!openId) return;
    const h = (e) => { if (e.key === "Escape") setOpenId(null); };
    window.addEventListener("keydown", h);
    document.body.style.overflow = "hidden";
    return () => { window.removeEventListener("keydown", h); document.body.style.overflow = ""; };
  }, [openId]);

  return (
    <section id="bestuur" data-testid="block-bestuur" style={{
      background: "var(--ink)", color: "var(--cream)",
      padding: "clamp(80px, 10vw, 140px) 0", borderTop: `1px solid ${line}`,
    }}>
      <div className="container">
        <Reveal>
          <div style={{ display: "flex", alignItems: "baseline", gap: 32, marginBottom: 40, flexWrap: "wrap" }}>
            <div className="eyebrow" style={{ color: gold }}>{inhoud.kleine_kop}</div>
            <div style={{ flex: 1, height: 1, background: line, minWidth: 40 }} />
          </div>
          <Rich as="h2" html={inhoud.kop} className="display swof-kop" style={{
            fontSize: "clamp(56px, 9vw, 168px)", lineHeight: 0.92, letterSpacing: "-0.035em",
            margin: "0 0 clamp(32px, 4vw, 56px)", fontWeight: 400,
          }} />
        </Reveal>

        <Reveal>
          <div style={{
            display: "flex", flexDirection: "column", alignItems: "center",
            gap: "clamp(28px, 3vw, 44px)", textAlign: "center", marginBottom: "clamp(64px, 8vw, 112px)",
          }}>
            <Rich as="p" html={inhoud.lede} style={{
              fontFamily: "var(--serif)", fontStyle: "italic", fontSize: "clamp(26px, 2.6vw, 40px)",
              lineHeight: 1.2, letterSpacing: "-0.015em", margin: 0,
              color: "var(--cream)", textWrap: "pretty", maxWidth: "28ch",
            }} />
            <Rich html={inhoud.body} className="swof-body" style={{
              fontFamily: "var(--serif)", fontSize: "clamp(17px, 1.35vw, 21px)",
              lineHeight: 1.6, margin: 0, color: subFg, textWrap: "pretty", maxWidth: "62ch",
            }} />
          </div>
        </Reveal>

        <Reveal>
          <div style={{
            display: "grid", gridTemplateColumns: "repeat(12, 1fr)", gap: 40,
            alignItems: "baseline", marginBottom: 40, paddingTop: 32, borderTop: `1px solid ${line}`,
          }}>
            <div style={{ gridColumn: "span 5" }}>
              <div className="eyebrow" style={{ color: gold, marginBottom: 16 }}>{inhoud.sub_kleine_kop}</div>
              <Rich as="h3" html={inhoud.sub_kop} className="swof-kop" style={{
                fontFamily: "var(--serif)", fontSize: "clamp(28px, 3.2vw, 48px)",
                margin: 0, fontWeight: 400, letterSpacing: "-0.01em", maxWidth: "16ch", lineHeight: 1.05,
              }} />
            </div>
            <div style={{ gridColumn: "7 / span 6" }}>
              <Rich as="p" html={inhoud.hulptekst} style={{
                fontFamily: "var(--serif)", fontSize: "clamp(15px, 1.1vw, 18px)",
                lineHeight: 1.55, margin: 0, color: subFg, textWrap: "pretty",
              }} />
            </div>
          </div>
        </Reveal>

        <Reveal stagger>
          <div className="bestuur-strip" style={{ display: "grid", gridTemplateColumns: "repeat(6, 1fr)", gap: 16 }}>
            {leden.map((m) => (
              <BestuurThumb key={m.id} m={m} portret={mediaById[m.portret_id]}
                isOpen={openId === m.id}
                onClick={() => setOpenId(openId === m.id ? null : m.id)} />
            ))}
          </div>
        </Reveal>
      </div>
      {open && <BioModal m={open} portret={mediaById[open.portret_id]} onClose={() => setOpenId(null)} />}
    </section>
  );
}

/* ———— 11. gala ———— */
export function BlockGala({ inhoud }) {
  const line = "var(--line)";
  const gold = "var(--gold)";
  const programma = inhoud.programma || [];
  return (
    <section id="gala" data-testid="block-gala" style={{
      background: "var(--ink)", color: "var(--cream)",
      padding: "clamp(100px, 12vw, 180px) 0", borderTop: `1px solid ${line}`,
      position: "relative", overflow: "hidden",
    }}>
      <div className="container">
        <Reveal>
          <div style={{ textAlign: "center", marginBottom: 72 }}>
            <div className="eyebrow" style={{ marginBottom: 20, color: gold }}>{inhoud.kleine_kop}</div>
            <Rich as="h2" html={inhoud.kop} className="display swof-kop" style={{
              fontSize: "clamp(48px, 7vw, 112px)", margin: 0, maxWidth: "16ch",
              marginInline: "auto", fontWeight: 400,
            }} />
          </div>
        </Reveal>
        <Reveal>
          <div style={{
            display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 0,
            border: "1px solid var(--line-strong)", marginBottom: 56, maxWidth: 900, marginInline: "auto",
          }}>
            {programma.map((p, i) => (
              <div key={i} style={{
                padding: "36px 20px", textAlign: "center",
                borderRight: i < programma.length - 1 ? `1px solid ${line}` : "none",
              }}>
                <div style={{
                  fontFamily: "var(--mono)", fontSize: 11, letterSpacing: "0.2em",
                  textTransform: "uppercase", color: gold, marginBottom: 14,
                }}>{p.tijd}</div>
                <div style={{ fontFamily: "var(--serif)", fontSize: "clamp(20px, 2vw, 28px)", lineHeight: 1.2 }}>
                  {p.omschrijving}
                </div>
              </div>
            ))}
          </div>
        </Reveal>
        <Reveal>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(12, 1fr)", gap: 40 }}>
            <Rich html={inhoud.show_tekst} className="swof-body" style={{
              gridColumn: "1 / -1", fontFamily: "var(--serif)", fontSize: "clamp(18px, 1.5vw, 23px)",
              lineHeight: 1.55, margin: 0, textWrap: "pretty", opacity: 0.88, maxWidth: "64ch",
            }} />
          </div>
        </Reveal>
      </div>
    </section>
  );
}

/* ———— 12. plek ———— */
export function BlockPlek({ inhoud }) {
  return (
    <section id="plek" data-testid="block-plek" style={{
      position: "relative", padding: "clamp(100px, 12vw, 180px) 0",
      background: "var(--ink)", overflow: "hidden", borderTop: "1px solid var(--line)",
    }}>
      <div className="container">
        <Reveal>
          <div style={{ display: "flex", alignItems: "baseline", gap: 32, marginBottom: 48, flexWrap: "wrap" }}>
            <div className="eyebrow" style={{ display: "flex", alignItems: "center", gap: 12, color: "var(--gold)" }}>
              <BGMark size={14} color="var(--gold)" opacity={0.85} />
              <span>{inhoud.kleine_kop}</span>
            </div>
            <div style={{ flex: 1, height: 1, background: "var(--line)", minWidth: 40 }} />
          </div>
          <Rich as="h2" html={inhoud.kop} className="display swof-kop" style={{
            fontSize: "clamp(64px, 11vw, 200px)", lineHeight: 0.92, letterSpacing: "-0.035em",
            margin: "0 0 clamp(48px, 6vw, 80px)", fontWeight: 400,
          }} />
        </Reveal>
        <Reveal>
          <Rich as="p" html={inhoud.lede} style={{
            maxWidth: "26ch", margin: "0 0 clamp(64px, 8vw, 112px)",
            fontFamily: "var(--serif)", fontStyle: "italic", fontSize: "clamp(30px, 3.2vw, 48px)",
            lineHeight: 1.18, letterSpacing: "-0.015em", color: "var(--cream)", textWrap: "pretty",
          }} />
        </Reveal>
        <Reveal>
          <Rich html={inhoud.body} className="swof-body swof-body-2col" style={{
            columnCount: 2, columnGap: "clamp(40px, 5vw, 80px)", fontFamily: "var(--serif)",
            fontSize: "clamp(18px, 1.45vw, 22px)", lineHeight: 1.6,
            color: "rgba(243,234,215,0.82)", textWrap: "pretty",
          }} />
        </Reveal>
        <Reveal>
          <div style={{
            marginTop: "clamp(64px, 8vw, 112px)", paddingTop: 40,
            borderTop: "1px solid var(--line)", display: "flex", justifyContent: "center",
          }}>
            <Rich as="p" html={inhoud.citaat} className="swof-kop" style={{
              fontFamily: "var(--serif)", fontSize: "clamp(28px, 3vw, 44px)", lineHeight: 1.2,
              letterSpacing: "-0.015em", margin: 0, color: "var(--cream)", textWrap: "balance",
              textAlign: "center", maxWidth: "24ch",
            }} />
          </div>
        </Reveal>
      </div>
    </section>
  );
}

/* ———— 13. signup / contact ———— */
export function BlockSignup({ inhoud }) {
  const gold = "var(--gold)";
  const line = "var(--line)";
  return (
    <section id="update" data-testid="block-signup" style={{
      background: "var(--ink)", color: "var(--cream)",
      padding: "clamp(100px, 11vw, 160px) 0", borderTop: `1px solid ${line}`, position: "relative",
    }}>
      <div className="container">
        <Reveal>
          <div style={{ display: "flex", alignItems: "baseline", gap: 32, marginBottom: 48, flexWrap: "wrap" }}>
            <div className="eyebrow" style={{ color: gold }}>{inhoud.kleine_kop}</div>
            <div style={{ flex: 1, height: 1, minWidth: 40, background: line }} />
          </div>
        </Reveal>
        <Reveal>
          <Rich as="h2" html={inhoud.kop} className="display swof-kop" style={{
            fontSize: "clamp(64px, 11vw, 200px)", lineHeight: 0.92, letterSpacing: "-0.035em",
            margin: "0 0 clamp(32px, 3.5vw, 56px)", fontWeight: 400,
          }} />
        </Reveal>
        <Reveal>
          <Rich as="p" html={inhoud.cta_regel} className="swof-kop" style={{
            fontFamily: "var(--serif)", fontStyle: "italic", fontSize: "clamp(32px, 4.2vw, 76px)",
            lineHeight: 1.05, letterSpacing: "-0.025em", margin: "0 0 clamp(56px, 6vw, 88px)",
            fontWeight: 400, color: "var(--cream)", opacity: 0.94, textWrap: "pretty",
          }} />
        </Reveal>
        <Reveal>
          <div style={{
            display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
            gap: "clamp(40px, 5vw, 80px)", paddingTop: "clamp(32px, 4vw, 56px)",
            borderTop: `1px solid ${line}`,
          }}>
            <div>
              <div className="eyebrow" style={{ color: gold, marginBottom: 18 }}>{inhoud.waarvoor_kop}</div>
              <Rich html={inhoud.hulptekst} className="swof-body" style={{
                fontFamily: "var(--serif)", fontSize: "clamp(18px, 1.4vw, 22px)",
                lineHeight: 1.55, margin: 0, textWrap: "pretty", opacity: 0.88, maxWidth: "36ch",
              }} />
            </div>
            <div>
              <div className="eyebrow" style={{ color: gold, marginBottom: 18 }}>{inhoud.email_kop}</div>
              <a href={`mailto:${inhoud.email}`} data-testid="signup-email" style={{
                display: "inline-block", fontFamily: "var(--serif)",
                fontSize: "clamp(26px, 2.6vw, 40px)", letterSpacing: "-0.015em", lineHeight: 1.1,
                color: "var(--cream)", textDecoration: "none",
                borderBottom: "1px solid var(--line-strong)", paddingBottom: 6,
                transition: "color .25s var(--ease), border-color .25s var(--ease)",
              }}
                onMouseEnter={(e) => { e.currentTarget.style.color = gold; e.currentTarget.style.borderBottomColor = gold; }}
                onMouseLeave={(e) => { e.currentTarget.style.color = "var(--cream)"; e.currentTarget.style.borderBottomColor = "var(--line-strong)"; }}
              >{inhoud.email}</a>
              <div style={{
                marginTop: 18, fontFamily: "var(--mono)", fontSize: 11,
                letterSpacing: "0.16em", textTransform: "uppercase", opacity: 0.5,
              }}>{inhoud.onder_regel}</div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}

/* ———— 14. partners ———— */
export function BlockPartners({ inhoud, partners, mediaById }) {
  const line = "var(--line)";
  const gold = "var(--gold)";
  return (
    <section id="partners" data-testid="block-partners" style={{
      background: "var(--ink)", color: "var(--cream)",
      padding: "clamp(64px, 7vw, 108px) 0", borderTop: `1px solid ${line}`,
    }}>
      <div className="container">
        <Reveal>
          <div style={{
            display: "flex", flexWrap: "wrap", gap: "clamp(32px, 4vw, 64px)",
            alignItems: "baseline", justifyContent: "space-between", marginBottom: "clamp(48px, 5vw, 72px)",
          }}>
            <div style={{ flex: "1 1 420px", maxWidth: 720 }}>
              <Rich as="h2" html={inhoud.kop} className="swof-kop" style={{
                fontFamily: "var(--serif)", fontSize: "clamp(40px, 5vw, 80px)",
                margin: 0, fontWeight: 400, lineHeight: 1, letterSpacing: "-0.02em",
              }} />
            </div>
            <Rich html={inhoud.intro} className="swof-body" style={{
              flex: "1 1 360px", maxWidth: 520, fontFamily: "var(--serif)",
              fontSize: "clamp(16px, 1.15vw, 19px)", lineHeight: 1.5, margin: 0,
              opacity: 0.82, textWrap: "pretty",
            }} />
          </div>
        </Reveal>

        <Reveal>
          <div style={{
            display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
            borderTop: `1px solid ${line}`, borderLeft: `1px solid ${line}`,
          }}>
            {partners.map((p) => {
              const logo = mediaById[p.logo_id];
              return (
                <div key={p.id} title={p.naam} aria-label={p.naam} style={{
                  padding: "clamp(40px, 5vw, 64px) 32px", display: "flex",
                  alignItems: "center", justifyContent: "center",
                  borderRight: `1px solid ${line}`, borderBottom: `1px solid ${line}`,
                  minHeight: 160, transition: "background .3s var(--ease)",
                }}
                  onMouseEnter={(e) => { e.currentTarget.style.background = "rgba(201,169,97,0.04)"; }}
                  onMouseLeave={(e) => { e.currentTarget.style.background = "transparent"; }}
                >
                  {logo ? (
                    <img src={logo.url} alt={logo.alt || p.naam} style={{
                      height: `clamp(32px, ${p.hoogte * 0.08}vw + 18px, ${p.hoogte}px)`,
                      maxWidth: "80%", width: "auto", objectFit: "contain",
                      filter: p.inkleuren
                        ? "brightness(0.97) sepia(0.38) saturate(0.75) hue-rotate(-6deg) opacity(0.9)"
                        : "opacity(0.85)",
                      transition: "filter .3s var(--ease), opacity .3s var(--ease)",
                    }} />
                  ) : (
                    <span style={{
                      fontFamily: "var(--serif)", fontSize: "clamp(18px, 1.6vw, 24px)",
                      textAlign: "center", color: "var(--cream)", opacity: 0.75, lineHeight: 1.25,
                    }}>{p.naam}</span>
                  )}
                </div>
              );
            })}
          </div>
        </Reveal>

        <Reveal>
          <div style={{
            marginTop: "clamp(32px, 3.5vw, 48px)", paddingTop: 24, borderTop: `1px solid ${line}`,
            display: "flex", flexWrap: "wrap", alignItems: "baseline",
            justifyContent: "space-between", gap: 20,
          }}>
            <Rich as="p" html={inhoud.onder_regel} style={{
              fontFamily: "var(--serif)", fontStyle: "italic", fontSize: "clamp(17px, 1.4vw, 22px)",
              lineHeight: 1.3, letterSpacing: "-0.005em", margin: 0,
              color: "var(--cream)", opacity: 0.9, textWrap: "pretty",
            }} />
            <a href="mailto:info@songwriterswalloffame.nl?subject=Partnerschap%20Songwriters%20Wall%20of%20Fame"
              className="gold-link" style={{ color: gold, fontSize: "clamp(15px, 1.15vw, 18px)" }}>
              {inhoud.knop_tekst}<span className="arrow">→</span>
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}

/* ———— fotogalerie (overlay, geen scroll-sectie) ———— */
export function FotogalerieOverlay({ inhoud, fotos, mediaById }) {
  const [open, setOpen] = useState(false);
  const [zoom, setZoom] = useState(null);
  const tiles = fotos.length ? fotos : Array.from({ length: inhoud.aantal_tegels || 24 }, () => null);
  useEffect(() => {
    const onOpen = () => setOpen(true);
    window.addEventListener("swof:open-galerie", onOpen);
    return () => window.removeEventListener("swof:open-galerie", onOpen);
  }, []);
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === "Escape" && zoom === null) setOpen(false);
    };
    window.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => { window.removeEventListener("keydown", onKey); document.body.style.overflow = ""; };
  }, [open, zoom]);
  if (!open) return null;
  return (
    <div id="fotogalerie" role="dialog" aria-label="Fotogalerie" data-testid="fotogalerie-overlay" style={{
      position: "fixed", inset: 0, zIndex: 500, background: "rgba(5,4,3,0.97)",
      backdropFilter: "blur(8px)", overflowY: "auto", color: "var(--cream)",
    }}>
      <div style={{
        position: "sticky", top: 0, zIndex: 2, display: "flex", alignItems: "baseline",
        justifyContent: "space-between", gap: 24, flexWrap: "wrap",
        padding: "clamp(20px, 3vw, 36px) clamp(20px, 4vw, 64px)",
        background: "linear-gradient(180deg, rgba(5,4,3,0.98) 0%, rgba(5,4,3,0.86) 100%)",
        borderBottom: "1px solid var(--line)",
      }}>
        <div>
          <div className="eyebrow" style={{ color: "var(--gold)", marginBottom: 10 }}>{inhoud.kleine_kop}</div>
          <Rich as="h2" html={inhoud.kop} className="swof-kop" style={{
            fontFamily: "var(--serif)", fontSize: "clamp(28px, 3.4vw, 52px)",
            margin: 0, fontWeight: 400, lineHeight: 1, letterSpacing: "-0.02em",
          }} />
        </div>
        <button onClick={() => setOpen(false)} data-testid="fotogalerie-close" style={{
          fontFamily: "var(--mono)", fontSize: 11, letterSpacing: "0.2em",
          textTransform: "uppercase", color: "var(--gold)", background: "transparent",
          border: "1px solid rgba(201,169,97,0.4)", padding: "10px 18px", cursor: "pointer",
        }}>Sluit ×</button>
      </div>
      <div style={{ padding: "clamp(20px, 3vw, 44px) clamp(20px, 4vw, 64px) clamp(48px, 6vw, 88px)" }}>
        <div className="fotogalerie-grid" style={{ display: "grid", gridTemplateColumns: "repeat(6, minmax(0, 1fr))", gap: 6 }}>
          {tiles.map((t, i) => (
            <button key={i} onClick={() => setZoom(i)} aria-label={`Foto ${i + 1}`} style={{
              padding: 0, border: "none", background: "transparent", cursor: "pointer", display: "block",
            }}>
              <PortraitSlot monogram={String(i + 1)} ratio="3 / 2" label={`foto ${i + 1}`}
                src={t ? mediaById[t.media_id]?.url : null} alt={t ? mediaById[t.media_id]?.alt : null}
                varianten={t ? mediaById[t.media_id]?.varianten : null}
                focus={t ? fotoFocus(mediaById[t.media_id]) : undefined} />
            </button>
          ))}
        </div>
      </div>
      {zoom !== null && tiles[zoom] && (
        <Lightbox items={tiles.map((t) => mediaById[t?.media_id]).filter(Boolean)} index={zoom}
          onClose={() => setZoom(null)} onChange={setZoom} testId="fotogalerie-lightbox" zIndex={600} />
      )}
    </div>
  );
}
